class DomainRestrictionPermissionChecker {
  hasPermission(currentUser, path) {
    if (!currentUser) {
      return false;
    }

    let { typeCd: userTypeCd } = currentUser;
    let isAllowed = false;

    if ( userTypeCd === "ISAD" ) {
      isAllowed = true;
    }

    return isAllowed;
  }
}

export default new DomainRestrictionPermissionChecker();
